import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { selectBackend } from "./api/selectBackend";
import { applySettingsToRoot, loadSettings } from "./state/settings";
import "./styles/theme.css";
import "./styles/accent.css";
import "./styles/app.css";

const container = document.getElementById("root");
if (container === null) throw new Error("index.html has no #root element");

applySettingsToRoot(loadSettings());

void selectBackend().then((backend) => {
  createRoot(container).render(
    <StrictMode>
      <App backend={backend} />
    </StrictMode>,
  );
});
